export const inserirRegexCep = (cep) => {
    let formartarCep = cep;

    if (cep !== null && cep !== undefined) {
        formartarCep = cep.replace(/\d/g, '');
        formartarCep = cep.replace(/(\d{5})(\d{3})/, '$1-$2');
    } else {
        formartarCep = '';
    }

    return formartarCep;
};

export const inserirRegexTelefone = (telefone) => {
    let formartarTelefone = telefone;

    if (telefone !== null && telefone !== undefined) {
        formartarTelefone = telefone.replace(/\d/g, '');
        formartarTelefone = telefone.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
    } else {
        formartarTelefone = ''
    };

    return formartarTelefone;
};

export const inserirRegexCnpj = (cnpj) => {
    let cnpjFormatado = cnpj;
    cnpjFormatado = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');

    return cnpjFormatado;
};

export const formatarCnpj = (cnpj) => {
    return cnpj
        .replace(/\D/g, "")
        .replace(/^(\d{2})(\d{0,3})/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d{0,3})/, "$1.$2.$3")
        .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d{0,4})/, "$1.$2.$3/$4")
        .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{0,2})/, "$1.$2.$3/$4-$5");
};

export const validarLetra = (valor) => {
    const letra = (valor.match(/[a-zA-Z]/) || []).length;
    return letra;
};

export const validarPonto = (valor) => {
    const ponto = (valor.match(/\./g) || []).length;

    return ponto;
};

export const validarVirgula = (valor) => {
    const virgula = (valor.match(/,/g) || []).length;

    return virgula;
};

export const validarVirgulaNoInicio = (valor) => {
    const virgulaNoIncio = valor.split('')[0] === ',';
    
    return virgulaNoIncio;
};  